import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MailX, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { PoweredBy } from "@/components/Footer";

export default function NewsUnsubscribe() {
  const { t } = useI18n();
  const [state, setState] = useState({ loading: true, error: "" });
  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    api.post(`/news/unsubscribe?uid=${encodeURIComponent(q.get("uid") || "")}&token=${encodeURIComponent(q.get("token") || "")}${q.get("v") ? `&v=${encodeURIComponent(q.get("v"))}` : ""}`)
      .then(() => setState({ loading: false, error: "" }))
      .catch((e) => setState({ loading: false, error: formatApiError(e) }));
  }, []);
  return (
    <div className="relative min-h-screen bg-[#04050a] grid place-items-center px-6" data-testid="news-unsub-page">
      <PoweredBy />
      <div className="cx-card rounded-3xl p-8 max-w-md w-full text-center">
        {state.loading ? <Loader2 className="w-8 h-8 mx-auto animate-spin text-[#3ad7ff]" /> : <MailX className="w-10 h-10 mx-auto text-[#a746ff]" />}
        <h1 className="font-display text-2xl text-white mt-4" data-testid="news-unsub-title">
          {state.loading ? "…" : state.error ? t("news.unsub_error") : t("news.unsub_done")}
        </h1>
        <p className="text-sm text-slate-400 mt-2" data-testid="news-unsub-msg">{state.error ? t("news.unsub_error_desc") : t("news.unsub_desc")}</p>
        <Link to="/" className="cx-btn inline-flex rounded-full px-6 py-3 text-sm font-semibold mt-6" data-testid="news-unsub-back">{t("news.unsub_back")}</Link>
      </div>
    </div>
  );
}
